'use strict';

import { CoreRepository } from '../CoreRepository';
import { AgencyAgencyDownline } from '../../Entities/Agency/AgencyAgencyDownline';
import { Agency } from '../../Entities/Agency/Agency';
import { AgencyAgencyDownlineCollection } from '../../Collections/Agency/AgencyAgencyDownlineCollection';

export class AgencyAgencyDownlineRepository extends CoreRepository {
  public getAgencyDownlineAgencies(userId: number, agencyId: number, options: object = {}) {
    return this.webAPI.getAgencyDownlineAgencies(userId, agencyId, options).then((response) => {
      const collection = new AgencyAgencyDownlineCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new AgencyAgencyDownline();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  /*
    public getAgencyAgencyDownlines(options: object = {}, criteria: object = null){
        if( !options )
        {
        options = {};
        }

        if( criteria )
        {
        options['criteria'] = criteria;
        }

        return this.webAPI.get(options)
        .then( response => {
            let collection = new AgencyAgencyDownlineCollection();

            response.data.forEach(collectionItemData => {
            let collectionItem = new AgencyAgencyDownline();
                collectionItem.hydrate(collectionItemData);

            collection.addItem(collectionItem);
            });

            collection.setOffset(response.offset);
            collection.setLimit(response.limit);
            collection.setTotal(response.total);

            return collection;
        });

    }
    */

  /*
    public getAgencyAgencyDownline(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getAgencyAgencyDownline(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let AgencyAgencyDownline = new AgencyAgencyDownline();
            AgencyAgencyDownline.hydrate(response);

            return AgencyAgencyDownline;
        });
    }

    public createAgencyAgencyDownline(payload: object = {}){  
    return this.webAPI.createAgencyAgencyDownline(payload)
      .then( response => {
        let AgencyAgencyDownline = new AgencyAgencyDownline();
        AgencyAgencyDownline.hydrate(response);

        return AgencyAgencyDownline;
      });
    }

    public updateAgencyAgencyDownline(payload: object = {}){  
        return this.webAPI.updateAgencyAgencyDownline(payload)
        .then( response => {
            let AgencyAgencyDownline = new AgencyAgencyDownline();
            AgencyAgencyDownline.hydrate(response);

            return AgencyAgencyDownline;
        });
    }

    public removeAgencyAgencyDownline( ){
        return this.webAPI.removeAgencyAgencyDownline()
        .then( response => {
            return response;
        });
    }
    */
}
